import Image from "next/image";
import checkWhite from "../../assets/icons/check-white-bg.png";

const MobileSidebar = ({ step }: { step: number }) => {
  const steps = ["Basic Details", "Address", "KYC"];

  return (
    <div className="w-full px-4 py-3 bg-blue-600 flex items-center justify-between rounded-t-md sm:hidden">
      {steps.map((label, index) => {
        const isCompleted = step > index + 1;
        const isActive = step === index + 1;

        return (
          <div key={index} className="flex flex-col items-center flex-1 relative">
            {/* Step Indicator */}
            <div
              className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold z-10
              ${isCompleted ? "bg-white-1" : isActive ? "bg-white-1 text-blue-600" : "border border-white-1 bg-blue-500 text-white-1"}`}
            >
              {isCompleted ? (
                <Image src={checkWhite} alt="check" width={24} height={24} />
              ) : (
                index + 1
              )}
            </div>

            {/* Step Label */}
            <span
              className={`text-[10px] mt-1 uppercase ${
                isActive || isCompleted ? "text-white-1 font-semibold" : "text-white-1/60"
              }`}
            >
              {label}
            </span>

            {/* Line connector (except last step) */}
            {index < steps.length - 1 && (
              <div className="absolute top-4 right-[-50%] w-full h-[1px] bg-white-1 opacity-50 z-0" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MobileSidebar;
